export function getBuiltinVersions() {
  return {
    FORC: '0.49.2',
    FUEL_CORE: '0.22.0',
    FUELS: '0.73.0',
  };
}
